import { useState } from 'react';
import '@/App.css';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginPage from './pages/LoginPage';
import HubPage from './pages/HubPage';
import AdminPage from './pages/AdminPage';
import { Toaster } from 'sonner';

function AppContent() {
  const { user, loading } = useAuth();
  const [showAdmin, setShowAdmin] = useState(false);

  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center" data-testid="loading-screen">
        <div className="flex flex-col items-center gap-4">
          <div className="w-8 h-8 border-2 border-[#0A84FF] border-t-transparent rounded-full animate-spin" />
          <p className="text-white/40 text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  if (showAdmin && ['admin', 'super_admin'].includes(user.role)) {
    return <AdminPage onBack={() => setShowAdmin(false)} />;
  }

  return <HubPage onAdminClick={() => setShowAdmin(true)} />;
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: '#1C1C1E',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            color: '#FFFFFF',
          },
        }}
      />
    </AuthProvider>
  );
}

export default App;
